module.exports = __webpack_public_path__ + "img/P150T_weapon_89.594833b8.png";